module.exports = __webpack_public_path__ + "static/media/ends_with_n.70004abc.mp3";